module.exports = __webpack_public_path__ + "img/beb6de6d-3e29-4031-844a-84187e57ba97.b56bcd7b.png";